<template>
  <div>
    <asn-shipment-form
      is-new
      :packing="packing"
      :saving="saving"
      :is-error-modal-shown="isErrorsModalShown"
      :error-modal-list="errorsModalList"
      @save="save"
      @restart="restart"
    />
    <shipment-notice-errors-modal
      v-model="isErrorsModalShown"
      :error-list="errorsModalList"
      :title="$t('views.shipment_notice_edit.validation_errors')"
    />
  </div>
</template>

<script>
import AsnShipmentForm from '@/components/consolidator-asn/AsnShipmentForm.vue';
import ShipmentNoticeErrorsModal from '@/components/asn/ShipmentNoticeErrorsModal.vue';

export default {
  name: 'ConsolidatorAsnShipment',

  components: {
    AsnShipmentForm,
    ShipmentNoticeErrorsModal,
  },

  data() {
    return {
      packing: [],
      saving: false,
      isErrorsModalShown: false,
      errorsModalList: [],
    };
  },

  methods: {
    async save() {
      this.saving = true;
      try {
        await this.$http.post('/shipment/asn-from-packing', { packing: this.packing });
        this.restart();
      } catch (error) {
        if (error.translatedErrorList) {
          this.errorsModalList = error.translatedErrorList;
          this.isErrorsModalShown = true;
        } else {
          this.$toast(this.$t('views.shipment_notice_list.asn_shipping_req_error'), {
            title: this.$t('toast.danger'),
            variant: 'danger',
          });
        }
      } finally {
        this.saving = false;
      }
    },

    restart() {
      this.packing = [];
    },
  },
};
</script>
